export const evaluationFormItems = {
  radioItems: [
    { label: 'forms.goalsNotAchieved', value: 1 },
    { label: 'forms.goalsInProgress', value: 2 },
    { label: 'forms.goalsAchieved', value: 3 },
    { label: 'forms.goalsSuspended', value: 4 },
    { label: 'forms.goalsOther', value: 5 },
  ],
}
